import { render } from "./actionModal.vue?vue&type=template&id=2c4e808c&scoped=true&ts=true"
import script from "./actionModal.vue?vue&type=script&lang=ts"
export * from "./actionModal.vue?vue&type=script&lang=ts"

import "./actionModal.vue?vue&type=style&index=0&id=2c4e808c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c4e808c"]])

export default __exports__